import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox";
import * as types from "../../constants/actionTypes";
import { setLoader } from "./actions";
import moment from "moment";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST, PUT } from "../../service/api";
import { Header } from "../../constants/headers";

const getStateModuleObat = (state) => state.ModuleObat;

export function* getMasterData() {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    let _body = {
      MasterData: [
        {
          ObjectName: "listObatKlinik",
          id: _id,
        },
      ],
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.GET_LIST_MASTER_DATA, _body);
    yield all(yield put({ type: types.MODULE_OBAT_MASTER_DATA_SUCCESS, property: "dataObat", value: response.data.listObatKlinik }));

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getDataObat(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    if (params.value == "all") {
      const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_OBAT_LIST_GET + _id);

      if (response.acknowledge == 1) {
        yield put({ type: types.MODULE_OBAT_DATA_GET_ALL_SUCCESS, value: response.data });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else if (params.value >= 0) {
      const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_OBAT_DETAIL_GET + params.value);
      if (response.acknowledge == 1) {
        const _data = response.data;
        const _formDetail = {
          f_id_obat: _data.f_id_obat,
          f_nama_obat: _data.f_nama_obat,
          f_kode_obat: _data.f_kode_obat,
          f_stok_obat: _data.f_stok_obat,
          f_harga_obat: _data.f_harga_obat,
          f_nama_produsen: _data.f_nama_produsen,
          f_satuan_hitung: _data.f_satuan_hitung,
          f_status_produsen: _data.f_nama_produsen ? true : false,
        };
        yield put({ type: types.MODULE_OBAT_DATA_GET_DETAIL_SUCCESS, value: _formDetail });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getObatMasuk(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    if (params.value == "all") {
      const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_OBAT_MASUK_LIST_GET + _id);

      if (response.acknowledge == 1) {
        yield put({ type: types.MODULE_OBAT_MASUK_DATA_GET_ALL_SUCCESS, value: response.data });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else if (params.value >= 0) {
      //nothing
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* postForm(params) {
  try {
    yield put(setLoader(true));

    let stateModuleObat = yield select(getStateModuleObat);
    const _data = stateModuleObat.formObat;
    const _body = {
      f_id_obat: _data.f_id_obat,
      f_nama_obat: _data.f_nama_obat,
      f_kode_obat: _data.f_kode_obat,
      f_stok_obat: _data.f_stok_obat,
      f_harga_obat: _data.f_harga_obat,
      f_nama_produsen: _data.f_status_produsen ? _data.f_nama_produsen : null,
      f_satuan_hitung: _data.f_satuan_hitung ? _data.f_satuan_hitung : null,
      f_id_klinik: JSON.parse(localStorage.getItem("UserData")).f_id_klinik,
    };

    if (!params.value) {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_OBAT_CREATE_POST, _body, { headers: Header() });
      if (response.acknowledge == 1) {
        yield put(setLoader(false));
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    } else {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_OBAT_UPDATE_POST, _body, { headers: Header() });
      if (response.acknowledge == 1) {
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* postForm2(params) {
  try {
    yield put(setLoader(true));

    let stateModuleObat = yield select(getStateModuleObat);
    const _data = stateModuleObat.formObatMasuk;

    const _body = {
      f_tgl_masuk: moment().format("YYYY-MM-DD HH:mm:ss"),
      f_tgl_kadaluarsa: moment(_data.f_tgl_kadaluarsa).format("YYYY-MM-DD"),
      f_catatan: _data.f_status_catatan ? _data.f_catatan : null,
      f_jmlh_obat: _data.f_jmlh_obat,
      f_id_obat: _data.f_id_obat,
      f_id_klinik: JSON.parse(localStorage.getItem("UserData")).f_id_klinik,
    };

    if (!params.value) {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_OBAT_MASUK_CREATE_POST, _body, { headers: Header() });
      if (response.acknowledge == 1) {
        // update jumlah obat

        yield put(setLoader(false));
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    } else {
      // nothing
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getObatKeluar(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    if (params.value == "all") {
      const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_OBAT_KELUAR_LIST_GET + _id);

      if (response.acknowledge == 1) {
        yield put({ type: types.MODULE_OBAT_KELUAR_DATA_GET_ALL_SUCCESS, value: response.data });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else if (params.value >= 0) {
      //nothing
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(types.MODULE_OBAT_DATA_GET, getDataObat),
    takeLatest(types.MODULE_OBAT_MASUK_DATA_GET, getObatMasuk),
    takeLatest(types.MODULE_OBAT_MASTER_DATA, getMasterData),
    takeLatest(types.MODULE_OBAT_SUBMIT_FORM, postForm),
    takeLatest(types.MODULE_OBAT_MASUK_SUBMIT_FORM, postForm2),
    takeLatest(types.MODULE_OBAT_KELUAR_DATA_GET, getObatKeluar),
  ]);
}
